import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Actions } from '../../../types/actions.type';
import { Flags } from '../../../types/flags.type';
import { LoginSharedActions } from '../login-shared/login-shared-actions';

@Component({
  selector: 'app-mu-modal-login',
  templateUrl: './mu-modal-login.component.html',
  styleUrls: ['./mu-modal-login.component.sass']
})
export class MuModalLoginComponent<FlagType> implements OnInit {

  @Input() id = 'mu-modal-dialog-login';
  @Input() showFlag: FlagType;
  @Input() actionFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() flagList: Flags<FlagType>;
  @Input() loginActions : Actions<LoginSharedActions, any>;
  @Output() eventCloseDialogModal = new EventEmitter();
  
  constructor() { /** */ }

// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void { /** */ }

  /**
   * fire the event when the modal is closed
   */
   _eventCloseDialogModal(): void {
    if (this.eventCloseDialogModal) {
      this.eventCloseDialogModal.emit();
      return environment.guardClause;
    }
    if (this.flagList.get(this.showFlag)) {
      this.flagList.disable(this.showFlag);
    }
  }

   /**
   * get modal state to show modal
   */
    get showModalState(): boolean {
      return this.flagList ? this.flagList.get(this.showFlag) : false;
    }
  
    /**
     * set modal state to show modal
     */
    set showModalState(value: boolean) {
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      value ? this.flagList.enable(this.showFlag) : this.flagList.disable(this.showFlag);
    }
}
